import styled from 'styled-components';

// Assets
import { brandColors, fonts } from '../../styles/variables';

const UnOrderedList = styled.ul`
  margin: 0;
  ${({ color }) => `
    color: ${color || brandColors.blue};
  `};
  font-family: ${fonts.athelas};
  font-size: 18px;
  font-style: italic;
  letter-spacing: 1px;
  line-height: 38px;

  li {
    padding: 0 0 16px 10px;
  }
`;

export { UnOrderedList };



// WEBPACK FOOTER //
// ./src/components/Layout/UnOrderedList.jsx